import { BehaviorSubject, Subject } from "rxjs";

import { RequestBase } from "./RequestBase";
import { AppShare,  } from "./AppContext";
import { CallApiComponent, CallApiSyncComponent, CallMultiApiComponent, MultiRequest } from "./CallApi";




abstract class IBloc {
    private _appShare?: AppShare
    // @ts-ignore
    public t: useTranslation
    protected _blocData: any = {}
    private _stream = new Map<string, Subject<any>>();
    constructor() {
        this.init()
    }
    init() { }
    public set appShare(value: AppShare) {
        this._appShare = value
    }
    public get appShare(): AppShare {
        return this._appShare!!
    }
    public setStream(key: string, value: any) {
        if (!this._stream.has(key)) {
            this._stream.set(key, new Subject())
        }
        this._stream.get(key)?.next(value)
        this.setDataField(key, value)
    }
    public setStreamBody(key: string, value: any, body = 'body') {
        if (!this._stream.has(key)) {
            this._stream.set(key, new Subject())
        }
        this._stream.get(key)?.next(value)
        this.setDataBodyField(key, value, body)
    }
    public getStream(key: string) {
        if (!this._stream.has(key)) {
            this._stream.set(key, new Subject())
        }
        return this._stream.get(key)!
    }
    public subscribe(key: string, onNext?: ((value: any) => void)) {
        if (!this._stream.has(key)) {
            this._stream.set(key, new Subject())
        }
        this._stream.get(key)?.subscribe(onNext)
    }
    public setDataField(field: string, value: any) {
        this._blocData[field] = value
    }
    public getDataField(field: string) {
        return this._blocData[field]
    }
    public setDataBodyField(field: string, value: any, body = 'body') {
        if (!this._blocData[body]) {
            this._blocData[body] = {}
        }
        this._blocData[body][field] = value
    }
    public getDataBodyField(field: string, body = 'body') {
        try {
            if (!this._blocData[body]) {
                return null
            }
            return this._blocData[body][field]
        } catch (e) {
            return null
        }

    }
    public setDataBody(value: any, body = 'body') {
        if (!this._blocData[body]) {
            this._blocData[body] = value
            return
        }
        this._blocData[body] = value
    }
    public getDataBody(body = 'body') {
        try {
            return this._blocData[body]
        } catch (e) {
            return null
        }
    }
    public log(log: any) {
        if (process.env!.NODE_ENV === "development") {
           
        }
    }
    public apiSingleRequest(api: RequestBase, onData: { (res: any): void }, handleRequest: {
        isShowLoading?: boolean | true, onError?: { (error: any): void } | null
    } = { isShowLoading: true, onError: null }) {
        CallApiComponent(api, onData, this.appShare?.apiHandler!!, handleRequest?.onError, handleRequest?.isShowLoading)
    }
    public async apiSyncSingleRequest(api: RequestBase, onData: { (res: any): void }, handleRequest: {
        isShowLoading?: boolean | true, onError?: { (error: any): void } | null
    } = { isShowLoading: true, onError: null }) {
        await CallApiSyncComponent(api, onData, this.appShare?.apiHandler!!, handleRequest?.onError, handleRequest?.isShowLoading)
    }
    public apiMultiRequest(requests: Array<MultiRequest>, onResponse?: { onData: { (key: string, res: any): void }, onAllData?: { (allRes: any): void } | null } | null, onComplete?: { (): void }, handleRequest: {
        isShowLoading?: boolean | true, onError?: { (error: any): void } | null, skipError?: boolean | false, receiveResponseEachRequest?: boolean | true, apiHandler?: any | null
    } = { isShowLoading: true, onError: null, skipError: true, receiveResponseEachRequest: true, apiHandler: null }) {
        setTimeout(async () => {
            await CallMultiApiComponent(requests, handleRequest?.apiHandler ? handleRequest?.apiHandler : this.appShare?.apiHandler!, onResponse?.onData, onResponse?.onAllData, onComplete, handleRequest?.skipError, handleRequest?.receiveResponseEachRequest, handleRequest?.onError, handleRequest?.isShowLoading)
        })

    }
    public async apiSyncMultiRequest(requests: Array<MultiRequest>, onResponse?: { onData: { (key: string, res: any): void }, onAllData?: { (allRes: any): void } | null } | null, onComplete?: { (): void }, handleRequest: {
        isShowLoading?: boolean | true, onError?: { (error: any): void } | null, skipError?: boolean | false, receiveResponseEachRequest?: boolean | true, apiHandler?: any | null
    } = { isShowLoading: true, onError: null, skipError: true, receiveResponseEachRequest: true, apiHandler: null }) {
        await CallMultiApiComponent(requests, handleRequest?.apiHandler ? handleRequest?.apiHandler : this.appShare?.apiHandler!, onResponse?.onData, onResponse?.onAllData, onComplete, handleRequest?.skipError, handleRequest?.receiveResponseEachRequest, handleRequest?.onError, handleRequest?.isShowLoading)

    }


    receiver(event: string, message: any) { }

    public updateBloc(appShare: AppShare, t: any) {
        appShare.app.blocChild = this
        this._appShare = appShare
        this.t = t
    }
    public dispose() {
        this.log('dispose')
        // this._stream.clear()
        // this._blocData={}
    }

    
}
export default IBloc